import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { memo } from 'react';
import { classNames } from '~/utils/classNames';

interface SurveyCheckboxItemProps extends RadixCheckbox.CheckboxProps {
  name: string;
  value: string;
  id: string;
  className?: string;
  children: React.ReactNode;
}

export const SurveyCheckboxItem = memo<SurveyCheckboxItemProps>(
  ({ name, value, id, children, className, ...props }) => (
    <RadixCheckbox.Root
      className={classNames(
        'bg-bolt-ds-surfaceTwo border border-bolt-ds-borderOutline rounded-lg px-4 min-h-12  [&[data-state=checked]]:bg-bolt-ds-surfaceThree [&[data-state=checked]]:border-bolt-ds-brand [&[data-state=checked]]:ring-1 [&[data-state=checked]]:ring-bolt-ds-brand hover:bg-bolt-ds-surfaceThree transition-theme',
        className,
      )}
      name={name}
      value={value}
      id={id}
      {...props}
    >
      {children}
    </RadixCheckbox.Root>
  ),
);
